import { useEffect, useState } from "react";
import { Rows, ListDashes } from "@phosphor-icons/react";

const KEY = "bg_density";

export const useDensity = () => {
  const [density, setDensity] = useState(
    () => localStorage.getItem(KEY) || "comfort",
  );
  useEffect(() => {
    localStorage.setItem(KEY, density);
  }, [density]);
  return [density, setDensity, density === "compact"];
};

export const DensityToggle = ({ density, onChange }) => (
  <div className="flex shrink-0 overflow-hidden rounded-md border border-zinc-800 bg-zinc-900">
    {[
      ["comfort", "Comfort", Rows],
      ["compact", "Compact", ListDashes],
    ].map(([key, label, Icon]) => (
      <button
        key={key}
        data-testid={`density-${key}`}
        onClick={() => onChange(key)}
        title={`${label} rows`}
        className={`flex h-12 items-center gap-2 px-3 text-xs font-semibold uppercase tracking-widest transition-colors duration-150 ${
          density === key
            ? "bg-indigo-500 text-white"
            : "text-zinc-400 hover:bg-zinc-800"
        }`}
      >
        <Icon size={16} weight="bold" />
        <span className="hidden sm:inline">{label}</span>
      </button>
    ))}
  </div>
);
